import React, { useState, useRef } from 'react';
import { Button, Icon, Dialog } from '@tencent/spaui';
import moment from 'moment';
import _ from 'lodash';
import useDialog from '../../../leads_component/shared-components/hooks/useDialog';
import MessageDialog from './MessageRemindDialog';
import { ListView } from '@tencent/ptp-fe-common';
import { RPCFactory } from '../../../utils/RequestUtil';
import { LeadsDataFilterShortcut as DATE_SHORTCUTS } from '../../../consts/Common';
import { CorpSelector } from './corpSelector';
import './index.less';
const dialog = Dialog.decorate();

const NOTICE_STATUS_MAP = {
  1: '待发送',
  2: '发送中',
  3: '已发送',
};

const NOTICE_TYPE_MAP = {
  1: '回访提醒',
  2: '跟进提醒',
};

const getOptionsListByMap = (obj) =>
  Object.keys(obj).map((key) => {
    let value = key;
    if (_.isInteger(+key)) {
      value = +key;
    }
    return { value, label: obj[key] };
  });

const Page = (props) => {
  const lvRef = useRef();
  const [editData, setEditData] = useState({}); // 编辑信息

  const dialogHooks = useDialog({ showDialog: false });

  // 默认展示的筛选条件，值为 filterControls 中的 name
  const defaultFilterKeys = ['noticeName', 'timeRange', 'status'];

  // 展示的列
  const showColumns = [
    'noticeName',
    'noticeType',
    'salesRange',
    'tag',
    'expectSendTime',
    'noticeStatus',
    'creatorWxWorkUserName',
    'options',
  ];

  const initQuery = {
    timeRange: {
      start_time: moment().subtract(30, 'day').format('YYYY-MM-DD'),
      end_time: moment().add(30, 'day').format('YYYY-MM-DD'),
    },
  };

  const getList = (params) =>
    new Promise((res, rej) => {
      RPCFactory.qwMessage
        .getList(params)
        .done((data) => {
          const arr = data.entities.map((item) => ({
            _data: item,
            ...item,
            noticeType: NOTICE_TYPE_MAP[item.noticeType],
          }));
          res({
            list: arr,
            page_info: {
              total_number: data.size,
            },
          });
        })
        .fail((ret, msg) => rej(msg));
    });

  const reloadList = () => {
    if (typeof lvRef.current.loadList !== 'function') return;
    lvRef.current.loadList();
  };

  const handlePreview = (data) => {
    dialog.setProps({
      style: {
        width: '500px',
      },
      title: '查看提醒详情',
      show: true,
      cancelButton: false,
      submitButton: true,
      closeButton: false,
      bodyStyle: { width: '500px', borderRadio: '8px' },
      headerStyle: { background: 'white' },
      children: (
        <div className="messageReview">
          <div className="row-message">
            <div className="row-message-left">提醒名称：</div>
            <div className="row-message-right">{data.noticeName}</div>
          </div>
          <div className="row-message">
            <div className="row-message-left">提醒类型：</div>
            <div className="row-message-right">回访提醒</div>
          </div>
          <div className="row-message">
            <div className="row-message-left">提醒内容：</div>
            <div className="row-message-right">{data.noticeContent}</div>
          </div>
          <div className="row-message">
            <div className="row-message-left">客户范围：</div>
            <div className="row-message-right">
              <div>
                销售：
                {data.salesListName &&
                  data.salesListName.map((item) => (
                    <span>
                      <ww-open-data type="userName" openid={item} />
                      <span> </span>
                    </span>
                  ))}
                {!data.salesListName && <span>全部</span>}
              </div>
              <div>
                标签：
                {data.tagListName &&
                  data.tagListName.map((item, index) => (
                    <span key={index} style={{ marginRight: '5px' }}>
                      {item}
                    </span>
                  ))}
                {!data.tagListName && <span>全部</span>}
              </div>
            </div>
          </div>
          <div className="row-message">
            <div className="row-message-left">发送时间：</div>
            <div className="row-message-right">{renderTime(0, 0, 0, data)}</div>
          </div>
        </div>
      ),
      onSubmit() {
        dialog.setProps({
          show: false,
        });

        // dialog.destory();
        // 也可以直接调用destory，不过调用这个之后，再次使用必须重新new一个
      },
    });
  };

  const handleEdit = (data) => {
    // e.preventDefault();
    setEditData({ ...data });
    dialogHooks.showAsAddModel();
  };
  const handleDelete = (data) => {
    console.log(data);
    dialog.setProps({
      style: {
        width: '500px',
      },
      title: '提示',
      show: true,
      cancelButton: true,
      submitButton: true,
      children: <div>确定要删除吗</div>,
      onClose() {
        dialog.setProps({
          show: false,
        });
      },
      onSubmit() {
        dialog.setProps({
          show: false,
        });
        RPCFactory.qwSidebar
          .noticeDelete({ noticeId: data.noticeId })
          .done(() => {
            reloadList();
          })
          .fail((ret, msg) => {
            window.alert(`服务器请求出错，出错信息：${msg}`);
          });
      },
      onCancel() {
        dialog.setProps({
          show: false,
        });
      },
    });
  };
  const renderStatus = (type, name, value, data) => {
    const style = {};
    if (data.noticeStatus === 3) {
      style.color = 'yellowgreen';
    }
    return <span style={style}>{NOTICE_STATUS_MAP[data.noticeStatus]}</span>;
  };

  const renderTag = (type, name, value, data) => {
    if (!data.tagListName) return '全部';
    return data.tagListName.join(',');
  };

  const renderRange = (type, name, value, data) => {
    if (!data.salesList || data.salesList.length === 0) return '全部';
    return (
      <div>
        {data.salesList.map((salesId, index) => (
          <span style={{ marginRight: '0px' }}>
            <ww-open-data type="userName" openid={salesId} />
            {index < data.salesList.length - 1 ? <span style={{ marginRight: '0px' }}>, </span> : null}
          </span>
        ))}
      </div>
    );
  };
  const renderCreeator = (type, name, value, data) => {
    return <ww-open-data type="userName" openid={data.creatorWxWorkUserId} />;
  };
  const renderTime = (type, name, value, data) => {
    const timeArr = data.expectSendTime.split(':');
    return `${timeArr[0]}:${timeArr[1]}`;
  };
  const renderOptions = (type, name, value, data) => {
    if (data.noticeStatus === 1) {
      return (
        <span>
          <a
            onClick={() => {
              handleEdit(data);
            }}
          >
            编辑
          </a>
          <a
            onClick={() => {
              handleDelete(data);
            }}
          >
            删除
          </a>
        </span>
      );
    }
    return (
      <a
        onClick={() => {
          handlePreview(data);
        }}
      >
        查看
      </a>
    );
  };

  const columnMap = {
    noticeName: { title: '提醒名称' },
    noticeType: { title: '消息类型' },
    salesRange: { title: '客服范围', render: renderRange },
    tag: { title: '标签', render: renderTag },
    expectSendTime: { title: '提醒时间', align: 'center', render: renderTime },
    noticeStatus: { title: '状态', render: renderStatus },
    creatorWxWorkUserName: { title: '创建人', render: renderCreeator },
    options: { title: '操作', render: renderOptions },
  };

  const filterControls = [
    {
      name: 'noticeName',
      title: '规则名称',
      type: 'search',
    },
    {
      name: 'timeRange',
      title: '时间范围',
      type: 'date-picker',
      clearable: false,
      config: {
        type: 'range',
        longestRange: '365',
        optionalStartRelativeDays: '-1000',
        optionalEndRelativeDays: '1000',
        useShortcut: true,
        shortcuts: DATE_SHORTCUTS,
      },
    },
    {
      name: 'noticeStatus',
      title: '状态',
      type: 'select',
      config: { data: getOptionsListByMap(NOTICE_STATUS_MAP) },
    },
  ];

  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        console.log('request', params);
        const obj = { ...params, noticeType: 1 };
        delete obj.timeRange;
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        if (_.isPlainObject(params.timeRange)) {
          obj.expectBeginTime = moment(params.timeRange.start_time).format('YYYY-MM-DD');
          obj.expectEndTime = moment(params.timeRange.end_time).format('YYYY-MM-DD');
        }
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },
    toolbarConfig: {
      left: (
        <div className="toolbar-right-group">
          <Button
            displayType="primary"
            onClick={() => {
              setEditData({});
              dialogHooks.showAsAddModel();
            }}
          >
            <Icon type="add" />
            添加提醒
          </Button>
        </div>
      ),
    },
    filterConfig: {
      resetable: false,
      controls: filterControls,
      customConfigure: null,
      defaultValuesByKey: initQuery,
    },
    batchConfig: null,
    tableConfig: {
      defaultPageSize: 10,
      select: 'single',
      columns: showColumns.map((key) => ({ ...columnMap[key], name: key })),
      optionalConfig: {
        type: 'optional',
        // 列表的唯一字段
        target: 'noticeId',
        multiple: true,
        canOptional: true,
      },
    },
  });

  return (
    <main className="main" id="main">
      <CorpSelector {...props} onChange={reloadList} />
      <div id="messageList">
        <div className="onlycard">
          <div className="card" style={{ paddingTop: 0 }}>
            <div className="datalist">
              <ListView
                className="lv"
                ref={lvRef}
                options={lvOptions}
                // payloads={this.payloads} // 不知道干啥用的
                // customFunctions={this.customFunctions} // 一样不知道干啥的
              />
            </div>
          </div>
        </div>
        {dialogHooks.showDialog ? (
          <MessageDialog
            {...dialogHooks}
            editData={editData}
            // wxAppId={wxAppHooks.props.value}
            onSuccess={() => {
              dialogHooks.setShowDialog(false);
              reloadList();
            }}
          />
        ) : null}
      </div>
    </main>

  );
};

export default Page;
